module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 12h4a2 2 0 012 2v4h3.172l-1.026-1.025A.5.5 0 0122 16.62V7.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5zm0 2v3.5a.5.5 0 00.5.5H18v-3.5a.5.5 0 00-.5-.5zm6 6v5a2 2 0 01-2 2H5.207a.5.5 0 01-.353-.854L8 23v-9a2 2 0 012-2h2V7a2 2 0 012-2h8a2 2 0 012 2v9l3.146 3.146a.5.5 0 01-.353.854zm-2 0h-4a2 2 0 01-2-2v-4h-1.5a.5.5 0 00-.5.5v9.121a.5.5 0 01-.146.354L8.828 25H17.5a.5.5 0 00.5-.5z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-conversation.svg
// module id = 680
// module chunks = 0